import { Settings as LayoutSettings } from '@ant-design/pro-layout';

export default {
  antd: {
    componentSize: 'small',
  },
  navTheme: 'dark',
  logo: 'https://static.utgl.io/admin/liverum-logo.svg',
  primaryColor: '#096dd9',
  layout: 'mix',
  headerHeight: 54,
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  // colorWeak: false,
  splitMenus: false,
  siderWidth: 240,
  menu: {
    locale: false,
  },
  title: '',
  pwa: true,
  iconfontUrl: '',
  layoutTitle: 'Liverum Admin Portal',
  worldCheckProvider: 'lseg',
} as LayoutSettings & {
  pwa: boolean;
  layoutTitle: string;
  worldCheckProvider: 'refinitiv' | 'lseg';
};
